import { render } from "./MediaArchive.vue?vue&type=template&id=7db96fc8&ts=true"
import script from "./MediaArchive.vue?vue&type=script&lang=ts"
export * from "./MediaArchive.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__